import script from "./Navigators.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigators.vue?vue&type=script&lang=ts&setup=true"

import "./Navigators.vue?vue&type=style&index=0&id=3eba32aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eba32aa"]])

export default __exports__